import React from 'react'
import PropTypes from 'prop-types'
import { DeleteOutlined } from '@ant-design/icons'

import facility_default from 'assets/facility_default.png'
import provider_default from 'assets/provider_default.png'

import FacilityProfileV2 from 'model/facilities/facilityProfileV2'
import Provider from 'model/provider/provider'

import {
  EntityItem,
  EntityPhoto,
  EntityInfo,
  EntityName,
  EntityAddress,
  DeleteIcon
} from './styled'

const SelectedEntity = ({
  entity,
  isFacility = false,
  onClick,
  onRemove,
  maxWidthValue = ''
}) => {
  if (!entity?.id) return false

  const name = isFacility ? entity.name : entity.full_name
  const default_image = isFacility ? facility_default : provider_default
  const hasImage = !!entity.image_url

  return (
    <EntityItem onClick={() => onClick(entity)}>
      <EntityPhoto
        src={hasImage ? entity.image_url : default_image}
        onError={({ currentTarget }) => {
          currentTarget.onerror = null // prevents looping
          currentTarget.src = default_image
        }}
      />
      <EntityInfo maxWidthValue={maxWidthValue}>
        <EntityName>{name}</EntityName>
        <EntityAddress>{entity.contacts.address}</EntityAddress>
      </EntityInfo>
      <DeleteIcon
        onClick={e => {
          e.stopPropagation()
          onRemove(entity)
        }}
      >
        <DeleteOutlined />
      </DeleteIcon>
    </EntityItem>
  )
}

SelectedEntity.propTypes = {
  entity: PropTypes.oneOfType([
    PropTypes.instanceOf(FacilityProfileV2),
    PropTypes.instanceOf(Provider)
  ]).isRequired,
  isFacility: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired,
  maxWidthValue: PropTypes.string
}

export default SelectedEntity
